// @ts-nocheck
import { useQuery } from "@tanstack/react-query";
import {
  BookOpen,
  BookCheck,
  UserPlus,
  ScrollText,
  Clock,
  Ticket,
} from "lucide-react";
import { cn } from "@libraryadmin/lib/utils";
import { getRecentActivity } from "@libraryadmin/services/api";
import { Skeleton } from "@libraryadmin/components/ui/skeleton";

const iconMap = {
  book_issued: BookOpen,
  book_returned: BookCheck,
  member: UserPlus,
  manuscript: ScrollText,
  ticket: Ticket,
};

const colorMap: Record<string, string> = {
  book_issued: "bg-primary/10 text-primary border-primary/20",
  book_returned: "bg-success/10 text-success border-success/20",
  member: "bg-accent/10 text-accent border-accent/20",
  manuscript: "bg-secondary/10 text-secondary border-secondary/20",
  ticket: "bg-warning/10 text-warning border-warning/20",
};

export function RecentActivity() {
  const { data: activities = [], isLoading } = useQuery({
    queryKey: ["recent-activity"],
    queryFn: getRecentActivity,
  });

  return (
    <div
      className="card-elevated animate-fade-in"
      style={{ animationDelay: "0.25s" }}
    >
      <div className="mb-5 flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-foreground">
            Recent Activity
          </h3>
          <p className="text-sm text-muted-foreground">
            Latest library transactions
          </p>
        </div>
        <div className="flex items-center gap-1 rounded-full bg-muted px-2 py-1 text-xs text-muted-foreground">
          <Clock className="h-3 w-3" />
          Live
        </div>
      </div>
      <div className="space-y-1">
        {isLoading
          ? Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="flex items-center gap-3 rounded-xl p-3">
                <Skeleton className="h-9 w-9 flex-shrink-0 rounded-lg" />
                <div className="flex-1 space-y-1.5">
                  <Skeleton className="h-3.5 w-32" />
                  <Skeleton className="h-3 w-48" />
                </div>
                <Skeleton className="h-3 w-16" />
              </div>
            ))
          : activities.map((activity, index) => {
              const Icon = iconMap[activity.icon] ?? BookOpen;
              return (
                <div
                  key={activity.id}
                  className="animate-fade-in group flex cursor-pointer items-start gap-3 rounded-xl p-3 opacity-0 transition-all duration-200 hover:bg-muted/50"
                  style={{
                    animationDelay: `${(index + 3) * 0.05}s`,
                    animationFillMode: "forwards",
                  }}
                >
                  <div
                    className={cn(
                      "rounded-lg border p-2",
                      colorMap[activity.icon] ?? colorMap.book_issued
                    )}
                  >
                    <Icon className="h-4 w-4" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-foreground transition-colors group-hover:text-primary">
                      {activity.title}
                    </p>
                    <p className="truncate text-xs text-muted-foreground">
                      {activity.description}
                    </p>
                  </div>
                  <span className="whitespace-nowrap text-[11px] text-muted-foreground">
                    {activity.timestamp}
                  </span>
                </div>
              );
            })}
      </div>
    </div>
  );
}
